import CloseIcon from "assets/images/CloseIcon";
import classNames from "classnames";
import {useEffect, useState} from "react";
import {addInsuranceCardModal as strings} from "strings";

import Button from "components/Button";
import DragAndDropFileUpload from "components/DragAndDropFileUpload";
import PageTitle from "components/PageTitle";
import Select from "components/Select";
import StyledModal from "components/StyledModal";

import * as models from "liberty-core/api/models";

import styles from "./AddInsuranceCardModal.module.css";

export default function AddInsuranceCardModal(
  props: (
    | {
        visible: boolean;
        onClose: () => void;
        onSave: (
          frontImage: File,
          backImage: File,
          selectedCardType: number,
        ) => void;
        cardTypes: models.InsuranceCardType[];
        isLoading: boolean;
      }
    | {
        visible: boolean;
        onClose: () => void;
        onSave: (frontImage: File, backImage: File) => void;
      }
  ) & {frontCard?: File; backCard?: File},
) {
  const [frontImage, setFrontImage] = useState<File | undefined>(
    props.frontCard,
  );
  const [backImage, setBackImage] = useState<File | undefined>(props.backCard);
  const [selectedCardTypeStr, setSelectedCardTypeStr] = useState("");

  useEffect(() => {
    setFrontImage(props.frontCard);
    setBackImage(props.backCard);
  }, [props.frontCard, props.backCard]);

  return (
    <StyledModal visible={props.visible} className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.detailsContainer}>
          <div className={styles.section}>
            <PageTitle className={styles.header}>{strings.title}</PageTitle>
            <button className={styles.close} onClick={props.onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className={styles.section}>
            <p className={styles.bold16}>{strings.header}</p>
            <p className={classNames(styles.regular16, styles.paddingBottom)}>
              {strings.instructions}
            </p>
          </div>
          <div className={styles.section}>
            <div className={styles.row}>
              <div className={styles.col}>
                <DragAndDropFileUpload
                  onUpload={setFrontImage}
                  existingImage={frontImage}
                />
                <span className={styles.bold16}>{strings.front}</span>
              </div>
              <div className={styles.col}>
                <DragAndDropFileUpload
                  onUpload={setBackImage}
                  existingImage={backImage}
                />
                <span className={styles.bold16}>{strings.back}</span>
              </div>
            </div>
          </div>
          {"cardTypes" in props && (
            <div className={classNames(styles.section, styles.selectSection)}>
              <Select
                value={selectedCardTypeStr}
                onChange={setSelectedCardTypeStr}
                options={props.cardTypes.map((t) => ({
                  value: `${t.cardType}`,
                  label: t.description,
                }))}
                placeholder={strings.selectType}
              />
            </div>
          )}
        </div>
        <div className={styles.buttonContainer}>
          <Button
            disabled={
              !frontImage ||
              !backImage ||
              ("cardTypes" in props && !selectedCardTypeStr)
            }
            onClick={() => {
              if (
                !frontImage ||
                !backImage ||
                ("cardTypes" in props && !selectedCardTypeStr)
              ) {
                return;
              }
              if ("cardTypes" in props) {
                props.onSave(
                  frontImage,
                  backImage,
                  parseInt(selectedCardTypeStr, 10),
                );
              } else {
                props.onSave(frontImage, backImage);
              }
            }}
            loading={"isLoading" in props && props.isLoading}
          >
            {strings.save}
          </Button>
        </div>
      </div>
    </StyledModal>
  );
}
